import { BaseService } from './base';
import { ProductCategory } from '../models/productCategory';

import { ApiRequest } from '../lib/request';
import type { ApiResponse } from '../lib/response';

export class ProductCategoryService extends BaseService<ProductCategory> {
  override model = ProductCategory;
  override modelName = 'productCategory';
  override modelLabel = 'Product Category';

  async deleteWithOptions(
    productCategory: ProductCategory,
    data: Record<string, any> = {},
  ): Promise<ApiResponse<ProductCategory>> {
    const request = new ApiRequest({
      method: 'DELETE',
      url: `${this.modelBaseUrl}/${productCategory.objectID()}`,
      data,
    });

    return await this.requestItem<ProductCategory>(request, this.model);
  }
}
